/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowrefinelogobigger4Inputs */

const en_aiflowrefinelogobigger4 = /** @type {(inputs: Aiflowrefinelogobigger4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bigger logo`)
};

const de_aiflowrefinelogobigger4 = /** @type {(inputs: Aiflowrefinelogobigger4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo größer`)
};

/**
* | output |
* | --- |
* | "Bigger logo" |
*
* @param {Aiflowrefinelogobigger4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowrefinelogobigger4 = /** @type {((inputs?: Aiflowrefinelogobigger4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowrefinelogobigger4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowrefinelogobigger4(inputs)
	return de_aiflowrefinelogobigger4(inputs)
});
export { aiflowrefinelogobigger4 as "aiFlowRefineLogoBigger" }